import { createReducer, on } from '@ngrx/store';
import { HealthFilterActions } from './health-filter.actions';
import { initialHealthFilterState } from './health-filter.state';

export const healthFilterReducer = createReducer(
  initialHealthFilterState,
  on(HealthFilterActions.reset, (_, { now }) => ({ ...initialHealthFilterState, now })),
  // The old cameras belong to the old site, so they cannot survive the change.
  on(HealthFilterActions.setSites, (state, { siteIds }) => ({ ...state, selectedSites: siteIds, selectedCameras: [] })),
  on(HealthFilterActions.setCameras, (state, { cameraIds }) => ({ ...state, selectedCameras: cameraIds })),
  on(HealthFilterActions.setPreset, (state, { days, now }) => ({ ...state, presetDays: days, customRange: null, now })),
  // An empty or inverted range has no window to chart, whichever control produced it.
  on(HealthFilterActions.setCustomRange, (state, { start, end }) => (end > start ? { ...state, customRange: { start, end } } : state)),
  on(HealthFilterActions.toggleState, (state, { state: picked }) => ({ ...state, selectedState: state.selectedState === picked ? null : picked })),
  on(HealthFilterActions.toggleDowntimeOnly, (state) => ({ ...state, downtimeOnly: !state.downtimeOnly })),
  on(HealthFilterActions.slide, (state, { now }) => ({ ...state, now })),
);
